import { render } from "./create-regional-dialog.vue?vue&type=template&id=4118a552&scoped=true&ts=true"
import script from "./create-regional-dialog.vue?vue&type=script&lang=ts"
export * from "./create-regional-dialog.vue?vue&type=script&lang=ts"

import "./create-regional-dialog.vue?vue&type=style&index=0&id=4118a552&lang=scss&scoped=true"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4118a552"]])

export default __exports__